import ImmutablePropTypes from "react-immutable-proptypes";
import React from "react";

export const ClubName = ({ club }) => <span>{club ? club.get("name") : null}</span>;

ClubName.propTypes = {
  club: ImmutablePropTypes.map
};

export default ClubName;



// WEBPACK FOOTER //
// ./src/app/components/CurrentClub/ClubName/ClubName.js